// extracted by mini-css-extract-plugin
module.exports = {"corpo":"Consultar_corpo__20JYg","tituloCard":"Consultar_tituloCard__3yoi4"};